package at.theatervogelweide.admin.contract

import kotlinx.serialization.json.Json

/** The JSON format of both transports, on both sides. */
val AdminJson = Json {
    // a newer server may add fields, the web app of an open tab should keep working
    ignoreUnknownKeys = true
    encodeDefaults = true
}
